export default function TestimonialSection() {
  return (
    <section className="py-24 px-6 lg:px-12 bg-sand">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
          <div className="lg:col-span-2 relative">
            <div className="bg-charcoal rounded-2xl p-12 lg:p-16 h-full flex flex-col justify-center lg:-ml-12 relative overflow-hidden">
              <div className="absolute -top-8 -left-8 w-32 h-32 rounded-full border-4 border-white overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/8018e3d88e1a7e3ecbc0561b11dfe204.jpg"
                  alt="Client"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="mt-16">
                <div className="flex text-gold mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xl"></i>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 bg-bone rounded-2xl p-8 lg:p-12 flex flex-col justify-center mt-8 lg:mt-0">
            <div className="text-gold text-6xl font-serif mb-6">"</div>
            <p className="text-charcoal text-xl lg:text-2xl font-light leading-relaxed mb-6">
              The IV Hydration Club transformed my recovery routine. After a demanding week, the NAD therapy gave me mental clarity I hadn't felt in months. The space is absolutely serene—nothing like a typical clinic. It's my monthly wellness ritual now.
            </p>
            <div>
              <p className="text-charcoal font-normal text-lg">Sarah Mitchell</p>
              <p className="text-gold text-sm font-light">NAD 500mg Therapy</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}